import { OpportunityDocument } from './opportunity-document';

export interface OpportunityDocumentsRes {
  count: number;
  totalCount: number;
  opportunityDocuments: Array<OpportunityDocument>;
}
